<template>
    <div class="options">
        <p class="text-answer">Antwoordtekst</p>
    </div>
</template>

<script setup lang="ts">

</script>
